import { render, staticRenderFns } from "./UsageDispensingShiptech.vue?vue&type=template&id=2c8e7114"
import script from "./UsageDispensingShiptech.vue?vue&type=script&lang=js"
export * from "./UsageDispensingShiptech.vue?vue&type=script&lang=js"
import style0 from "./UsageDispensingShiptech.vue?vue&type=style&index=0&id=2c8e7114&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports